export interface IAuthenticationFormFields {
    authentication: string[];
    serverInstanceURL: string;
    [AuthenticationProviderKeys.ActiveDirectory]: {
        domain: string;
        enableJWT: boolean;
        audienceURL: string;
    };
    [AuthenticationProviderKeys.IdentityServer]: {
        clientId: string;
        authority: string;
    };
    [AuthenticationProviderKeys.GoogleConfiguration]: {
        clientId: string;
        resource: string;
        returnURL: string;
    };
    [AuthenticationProviderKeys.Okta]: {
        clientId: string;
        authority: string;
    };
    [AuthenticationProviderKeys.Salesforce]: {
        consumerKey: string;
        consumerSecret: string;
    };
    [AuthenticationProviderKeys.MSAzureActiveDirectory]: {
        clientId: string;
        returnURL: string;
        resource: string;
        useMSAuthenticatorApp: boolean;
    };
    [AuthenticationProviderKeys.MSAzureActiveDirectoryChina]: {
        clientId: string;
        returnURL: string;
        resource: string;
        useMSAuthenticatorApp: boolean;
    };
    [AuthenticationProviderKeys.PingFederate]: {
        clientId: string,
        authority: string,
        usernameClaimType: string
    };
    [AuthenticationProviderKeys.AmazonCognito]: {
        clientId: string,
        authority: string,
        userImpersonationScopeURL: string
    }
}

export enum AuthenticationProviderKeys {
    ActiveDirectory = 'activeDirectoryConfiguration',
    AgilePointID = 'agilePiontNXConfiguration', //API is sending 'agilePiontNXConfiguration'
    GoogleConfiguration = 'googleConfiguration',
    IdentityServer = 'identityServerConfiguration',
    Okta = 'oktaConfiguration',
    Salesforce = 'salesforceConfiguration',
    MSAzureActiveDirectory = 'officeConfiguration',
    MSAzureActiveDirectoryChina = 'officeConfigurationChina',
    PingFederate = 'pingFederateConfiguration',
    AmazonCognito = 'amazonCognitoConfiguration'
}
